import React from 'react';
import PropTypes from 'prop-types';

const Fieldset = ({ title, children }) => {
  return (
    <fieldset className="border border-gray-300 p-3 rounded mb-2">
      {title && <legend className="px-2">{title}</legend>}
      {children}
    </fieldset>
  );
};

Fieldset.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Fieldset;
